<app-menu>
    <div class="form-container">
        <div class="step-content">
            <!-- Progress Bar above each step of form to detail which step is active-->
            <ul class="progress-bar">
                <li [class.active]="step === 1">
                    <span class="icon"><i class="fas fa-person"></i></span>
                    <br>
                    <span class="label">Customer</span>
                </li>
                <li [class.active]="step === 2">
                    <span class="icon"><i class="fas fa-truck-fast"></i></span>
                    <br>
                    <span class="label">Shipper</span>
                </li>
                <li [class.active]="step === 3">
                    <span class="icon"><i class="fas fa-list"></i></span>
                    <br>
                    <span class="label">Consignee</span>
                </li>
                <li [class.active]="step === 4">
                    <span class="icon"><i class="fas fa-truck-ramp-box"></i></span>
                    <br>
                    <span class="label">Load Details</span>
                </li>
                <li [class.active]="step === 5">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <br>
                    <span class="label">Rates</span>
                </li>
            </ul>

            <!-- Customer Form -->
            <div *ngIf="step === 1">
                <form [formGroup]="customerForm">
                    <div class="section-select">
                        <mat-form-field class="input-container">
                            <mat-label>Customer Name</mat-label>
                            <input matInput placeholder="Start typing company name..." formControlName="customer_company_name">
                        </mat-form-field>
                        <mat-form-field class="input-container">
                            <mat-label>Customer Address</mat-label>
                            <input matInput placeholder="Select Customer First" formControlName="customer_address">
                        </mat-form-field>
                    </div>

                    <div class="section-cards">
                        <mat-card class="card">
                            <mat-card-header>
                                <mat-card-title>Documentation Requirements</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="section-card-checkboxes">
                                    <mat-checkbox formControlName="customer_shipping_bol">Shipping BOL</mat-checkbox>
                                    <mat-checkbox formControlName="customer_invoice_bol">Invoice BOL</mat-checkbox>
                                    <mat-checkbox formControlName="customer_invoice_pod_required">Invoice POD</mat-checkbox>
                                    <mat-checkbox formControlName="customer_invoice_po_required">PO Number</mat-checkbox>
                                    <mat-checkbox formControlName="customer_rate_quote">Rate Quote Invoice</mat-checkbox>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header>
                                <mat-card-title>Notification Requirements</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="section-card-checkboxes">
                                    <mat-checkbox formControlName="customer_at_pickup_notification">At Pick-Up</mat-checkbox>
                                    <mat-checkbox formControlName="customer_delayed_pickup_notification">Delayed Pick-up</mat-checkbox>
                                    <mat-checkbox formControlName="customer_at_delivery_notification">At Delivery</mat-checkbox>
                                    <mat-checkbox formControlName="customer_delayed_delivery_notification">Delayed Delivery</mat-checkbox>
                                    <mat-checkbox formControlName="customer_assessorials_incurred_notification">Assessorials Incurred</mat-checkbox>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header>
                                <mat-card-title>Transportation Requirements</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="section-card-checkboxes">
                                    <mat-checkbox formControlName="customer_csa">CSA</mat-checkbox>
                                    <mat-checkbox formControlName="customer_fast">FAST</mat-checkbox>
                                    <mat-checkbox formControlName="customer_ace">ACE</mat-checkbox>
                                    <mat-checkbox formControlName="customer_aci">ACI</mat-checkbox>
                                    <mat-checkbox formControlName="customer_ct_pat">CT PAT</mat-checkbox>
                                    <mat-checkbox formControlName="customer_canada_bond">Canada Bond</mat-checkbox>
                                    <mat-checkbox formControlName="customer_us_bond">US Bond</mat-checkbox>
                                    <mat-checkbox formControlName="customer_hazmat">HAZMAT</mat-checkbox>
                                    <mat-checkbox formControlName="customer_protect_from_freezing">Protect From Freezing</mat-checkbox>
                                    <mat-checkbox formControlName="customer_heated">Heated</mat-checkbox>
                                    <mat-checkbox formControlName="customer_refrigeration">Refrigeration</mat-checkbox>
                                    <mat-checkbox formControlName="customer_food_grade">Food Grade</mat-checkbox>
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="card">
                            <mat-card-header>
                                <mat-card-title>Special Requirements</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <mat-checkbox formControlName="customer_consignee_agreement">Consignee Agreement</mat-checkbox>
                                <mat-form-field>
                                    <mat-label>Rate Method</mat-label>
                                    <mat-select formControlName="rate_method" required>
                                        <mat-option *ngFor="let type of typeListRateMethod"
                                            [value]="type">{{type}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <mat-card class="card">
                        <mat-card-header>
                            <mat-card-title>Third Party Bill-To</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="section-select">
                                <mat-form-field class="input-container">
                                    <mat-label>Company Name</mat-label>
                                    <input matInput placeholder="Start typing company name..."
                                        formControlName="bill_to_company_name">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Company Address</mat-label>
                                    <input matInput placeholder="Select Company First" formControlName="bill_to_address">
                                </mat-form-field>
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <div class="form-actions-container">
                        <div class="form-actions">
                            <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Shipper Form -->
            <div *ngIf="step === 2">
                <form [formGroup]="shipperForm">
                    <div class="section-select">
                        <mat-form-field class="input-container">
                            <mat-label>Shipper Name</mat-label>
                            <input matInput placeholder="Start typing shipper name..." formControlName="shipper_company_name">
                        </mat-form-field>
                        <mat-form-field class="input-container">
                            <mat-label>Shipper Address</mat-label>
                            <input matInput placeholder="Select Shipper First" formControlName="shipper_address">
                        </mat-form-field>
                    </div>
                    <div class="section">
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>Shipper Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="form-field-container">
                                <div class="section-card-checkboxes">
                                    <mat-checkbox>Is there a loading dock?</mat-checkbox>
                                    <mat-checkbox>Does it require a tailgate at pick-up?</mat-checkbox>
                                    <mat-checkbox>Is space available for a 53ft truck to park/offload?</mat-checkbox>
                                    <mat-checkbox>Does it require a straight truck at pick-up</mat-checkbox>
                                    <mat-checkbox>Requires BOL</mat-checkbox>
                                    <mat-checkbox>Residential</mat-checkbox>
                                    <mat-checkbox>Commercial</mat-checkbox>
                                    <mat-checkbox>Job Site</mat-checkbox>
                                    <mat-checkbox>Convention Center</mat-checkbox>
                                    <mat-checkbox>Pop-up Store</mat-checkbox>
                                    <mat-checkbox>Appointment Required?</mat-checkbox>
                                </div>
                                <mat-form-field class="input-container">
                                    <mat-label>Pickup Reference</mat-label>
                                    <input matInput formControlName="shipper_pickup_reference">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Estimated Pickup Date</mat-label>
                                    <input matInput formControlName="estimated_date_shipper">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Estimated Pickup Time Start</mat-label>
                                    <input matInput type="time" formControlName="estimated_time_start_shipper">
                                </mat-form-field>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </form>
                <div class="section">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Default Service Charges</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <form [formGroup]="defaultServiceChargeForm">
                                <div [formGroup]="defaultServiceChargeForm">
                                    <!-- Additional address sections added dynamically -->
                                    <div *ngFor="let serviceChargeFormGroup of serviceChargesShipper; let i = index"
                                        [formGroup]="serviceChargeFormGroup" style="margin-bottom: 1em;">
                                        <h3>Added Service Charge {{i+1}}</h3>
                                        <div style="display: flex; flex-wrap: wrap">
                                            <mat-form-field>
                                                <mat-label>Service</mat-label>
                                                <mat-select formControlName="service" (selectionChange)="onServiceChange(i, 'shipper')">
                                                    <mat-option *ngFor="let type of typeListService"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Service Type</mat-label>
                                                <mat-select formControlName="service_type">
                                                    <mat-option *ngFor="let type of getService(serviceChargeFormGroup.get('service')?.value)"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div style="align-items: center; justify-content: center;">
                                            <button mat-raised-button color="warn"
                                                (click)="removeServiceCharge(i, 'shipper')">Remove
                                                Service</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div style="margin-top: 2em">
                                <button mat-raised-button color="primary" (click)="addServiceCharge('shipper')">Add New
                                    Service</button>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="form-actions-container">
                    <div class="form-actions">
                        <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                        <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                    </div>
                </div>
            </div>

            <!-- Consignee Form -->
            <div *ngIf="step === 3">
                <form [formGroup]="consigneeForm">
                    <div class="section-select">
                        <mat-form-field class="input-container">
                            <mat-label>Consignee Name</mat-label>
                            <input matInput placeholder="Start typing consignee name..."
                                formControlName="consignee_company_name">
                        </mat-form-field>
                        <mat-form-field class="input-container">
                            <mat-label>Consignee Address</mat-label>
                            <input matInput placeholder="Select Consignee First" formControlName="consignee_address">
                        </mat-form-field>
                    </div>
                    <div class="section">
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>Consignee Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="form-field-container">
                                <div class="section-card-checkboxes">
                                    <mat-checkbox>Is there a loading dock?</mat-checkbox>
                                    <mat-checkbox>Does it require a tailgate at pick-up?</mat-checkbox>
                                    <mat-checkbox>Is space available for a 53ft truck to park/offload?</mat-checkbox>
                                    <mat-checkbox>Does it require a straight truck at pick-up</mat-checkbox>
                                    <mat-checkbox>Requires BOL</mat-checkbox>
                                    <mat-checkbox>Residential</mat-checkbox>
                                    <mat-checkbox>Commercial</mat-checkbox>
                                    <mat-checkbox>Job Site</mat-checkbox>
                                    <mat-checkbox>Convention Center</mat-checkbox>
                                    <mat-checkbox>Pop-up Store</mat-checkbox>
                                    <mat-checkbox>Appointment Required?</mat-checkbox>
                                </div>
                                <mat-form-field class="input-container">
                                    <mat-label>Delivery Reference</mat-label>
                                    <input matInput formControlName="consignee_delivery_reference">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Estimated Delivery Date</mat-label>
                                    <input matInput formControlName="estimated_date_consignee">
                                </mat-form-field>
                                <mat-form-field class="input-container">
                                    <mat-label>Estimated Delivery Time Start</mat-label>
                                    <input matInput type="time" formControlName="estimated_time_end_consignee">
                                </mat-form-field>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </form>
                <div class="section">
                    <mat-card>
                        <mat-card-header>
                            <mat-card-title>Default Service Charges</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <form [formGroup]="defaultServiceChargeForm">
                                <div [formGroup]="defaultServiceChargeForm">
                                    <!-- Additional address sections added dynamically -->
                                    <div *ngFor="let serviceChargeFormGroup of serviceChargesConsignee; let i = index"
                                        [formGroup]="serviceChargeFormGroup" style="margin-bottom: 1em;">
                                        <h3>Added Service Charge {{i+1}}</h3>
                                        <div style="display: flex; flex-wrap: wrap">
                                            <mat-form-field>
                                                <mat-label>Service</mat-label>
                                                <mat-select formControlName="service" (selectionChange)="onServiceChange(i, 'consignee')">
                                                    <mat-option *ngFor="let type of typeListService"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Service Type</mat-label>
                                                <mat-select formControlName="service_type">
                                                    <mat-option *ngFor="let type of getService(serviceChargeFormGroup.get('service')?.value)"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div style="align-items: center; justify-content: center;">
                                            <button mat-raised-button color="warn"
                                                (click)="removeServiceCharge(i, 'consignee')">Remove
                                                Service</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div style="margin-top: 2em">
                                <button mat-raised-button color="primary" (click)="addServiceCharge('consignee')">Add
                                    New
                                    Service</button>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="form-actions-container">
                    <div class="form-actions">
                        <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                        <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                    </div>
                </div>
            </div>

            <!-- Load Details Form -->
            <div *ngIf="step === 4">
                <form [formGroup]="loadForm">

                    <div class="section-select">
                        <mat-form-field class="input-container">
                            <mat-label>Order Scope</mat-label>
                            <mat-select formControlName="order_scope">
                                <mat-option *ngFor="let type of typeListOrderScope" [value]="type">{{type}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="input-container">
                            <mat-label>Order Scope Secondary</mat-label>
                            <mat-select formControlName="order_scope_secondary">
                                <mat-option *ngFor="let type of typeListOrderScope" [value]="type">{{type}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="section">
                        <mat-card class="card">
                            <mat-card-header>
                                <mat-card-title>Load Details</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="section-cards">
                                    <mat-card class="card">
                                        <mat-card-header>
                                            <mat-card-title>Order Type</mat-card-title>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <div class="section-card-checkboxes">
                                                <mat-checkbox>USA Domestic</mat-checkbox>
                                                <mat-checkbox>Canada Domestic</mat-checkbox>
                                                <mat-checkbox>USA Crossborder</mat-checkbox>
                                                <mat-checkbox>Canada Crossborder</mat-checkbox>
                                                <mat-checkbox>Air Freight</mat-checkbox>
                                                <mat-checkbox>Client Generated</mat-checkbox>
                                                <mat-checkbox>Local Delivery</mat-checkbox>
                                                <mat-checkbox>Ocean Freight</mat-checkbox>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                    <mat-card class="card">
                                        <mat-card-header>
                                            <mat-card-title>Packaging Type</mat-card-title>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <div class="section-card-checkboxes">
                                                <mat-checkbox>Palleted</mat-checkbox>
                                                <mat-checkbox>Carton</mat-checkbox>
                                                <mat-checkbox>Crate</mat-checkbox>
                                                <mat-checkbox>Loose/Floor</mat-checkbox>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                    <mat-card class="card">
                                        <mat-card-header>
                                            <mat-card-title>Operations</mat-card-title>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <div class="section-card-checkboxes">
                                                <mat-checkbox>Carrier Rated</mat-checkbox>
                                                <mat-checkbox>Carrier Re-Rated</mat-checkbox>
                                                <mat-checkbox>Straps and Bars</mat-checkbox>
                                                <mat-checkbox>Protective Equipment</mat-checkbox>
                                            </div>
                                            <mat-form-field class="input-container">
                                                <mat-label>Operations Notation</mat-label>
                                                <input matInput formControlName="operations_notation">
                                            </mat-form-field>
                                        </mat-card-content>
                                    </mat-card>
                                    <mat-card class="card">
                                        <mat-card-header>
                                            <mat-card-title>Equipment</mat-card-title>
                                        </mat-card-header>
                                        <mat-card-content>
                                            <mat-form-field>
                                                <mat-label>Type of Equipment</mat-label>
                                                <mat-select required>
                                                    <mat-option *ngFor="let type of typeListEquipmentType"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Equipment Options</mat-label>
                                                <mat-select required>
                                                    <mat-option *ngFor="let type of typeListEquipmentOptions"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Partial or Full</mat-label>
                                                <mat-select required>
                                                    <mat-option *ngFor="let type of typeListPartialFull"
                                                        [value]="type">{{type}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="section">
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>Pallets</mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="form-field-container">
                                <form [formGroup]="loadForm">
                                    <div [formGroup]="loadForm">
                                        <!-- Additional address sections added dynamically -->
                                        <div *ngFor="let palletSetFormGroup of palletSets; let i = index"
                                            [formGroup]="palletSetFormGroup" style="margin-bottom: 1em;">
                                            <h3>Pallet Set {{i+1}}</h3>
                                            <mat-tab-group>
                                                <mat-tab label="Pallets">
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Number of Pallets</mat-label>
                                                            <input type="number" matInput formControlName="num_pallets">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Length (inches)</mat-label>
                                                            <input type="number" matInput formControlName="length">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Width (inches)</mat-label>
                                                            <input type="number" matInput formControlName="width">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Height (inches)</mat-label>
                                                            <input type="number" matInput formControlName="height">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Weight (pounds)</mat-label>
                                                            <input type="number" matInput formControlName="weight">
                                                        </mat-form-field>
                                                    </div>
                                                    <div style="align-items: center; justify-content: center;">
                                                        <button mat-raised-button color="warn"
                                                            (click)="removePalletSet(i)" *ngIf="i > 0">Remove
                                                            Pallet Set</button>
                                                    </div>
                                                </mat-tab>
                                                <mat-tab label="Products">
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Model Number</mat-label>
                                                            <input matInput formControlName="num_pallets">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Quantity</mat-label>
                                                            <input type="number" matInput formControlName="length">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Length</mat-label>
                                                            <input type="number" matInput formControlName="length">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Width</mat-label>
                                                            <input type="number" matInput formControlName="width">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Height</mat-label>
                                                            <input type="number" matInput formControlName="height">
                                                        </mat-form-field>
                                                        <mat-form-field class="input-container">
                                                            <mat-label>Weight</mat-label>
                                                            <input type="number" matInput formControlName="weight">
                                                        </mat-form-field>
                                                    </div>
                                                    <mat-form-field class="input-container">
                                                        <mat-label>Description</mat-label>
                                                        <input matInput formControlName="weight">
                                                    </mat-form-field>
                                                    <div style="align-items: center; justify-content: center;">
                                                        <button mat-raised-button color="warn"
                                                            (click)="removePalletSet(i)">Remove
                                                            Pallet Set</button>
                                                    </div>
                                                </mat-tab>
                                            </mat-tab-group>
                                        </div>
                                    </div>
                                </form>
                                <div style="margin-top: 2em">
                                    <button mat-raised-button color="primary" (click)="addPalletSet()">Add New
                                        Pallet Set</button>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                </form>
                <div class="form-actions-container">
                    <div class="form-actions">
                        <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                        <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                    </div>
                </div>
            </div>

            <!-- Rates Form -->
            <div *ngIf="step === 5">
                <div class="form-actions-container">
                    <div class="form-actions">
                        <button mat-raised-button color="primary" (click)="prevStep()">Back</button>
                        <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-menu>